// Licencias 3CX por vencer de los revendedores (objeto licencia3cx de la app, llenado con la API de partner de 3CX).
import { gqlTodos } from './gql';
import { update } from './rest';
import { request } from './http';

export type EstadoLicencia = 'POR_VENCER' | 'VENCIDA' | 'RENOVADA' | 'FUERA_DE_VENTANA';
export type Licencia3cx = {
  id: string;
  clave: string;
  vence: string | null;
  edicion: string;
  perpetua: boolean;
  llamadas: number | null;
  extensiones: number | null;
  tipo: string;
  estado: EstadoLicencia;
  aviso45: string | null;
  aviso25: string | null;
  avisoInterno: string | null;
  // Cotizacion enviada al revendedor (D58): la detecta la app en los correos de quien cotiza, o se marca a mano.
  cotizada: string | null;
  cotizadaAsunto: string;
  nota: string;
  empresa: { id: string; nombre: string; correo: string; idioma: 'ES' | 'EN' | null } | null;
};

type Raw = {
  id: string;
  name: string;
  vence: string | null;
  edicion: string | null;
  perpetua: boolean | null;
  llamadas: number | null;
  extensiones: number | null;
  tipo: string | null;
  estado: EstadoLicencia | null;
  aviso45: string | null;
  aviso25: string | null;
  avisoInterno: string | null;
  cotizada?: string | null;
  cotizadaAsunto?: string | null;
  nota: string | null;
  empresa?: { id: string; name?: string; correoLicencias?: string | null; idiomaAvisos?: 'ES' | 'EN' | null } | null;
};

const aLicencia = (r: Raw): Licencia3cx => ({
  id: r.id,
  clave: r.name,
  vence: r.vence,
  edicion: r.edicion ?? '',
  perpetua: !!r.perpetua,
  llamadas: r.llamadas,
  extensiones: r.extensiones,
  tipo: r.tipo ?? 'Commercial',
  estado: r.estado ?? 'POR_VENCER',
  aviso45: r.aviso45,
  aviso25: r.aviso25,
  avisoInterno: r.avisoInterno,
  cotizada: r.cotizada ?? null,
  cotizadaAsunto: r.cotizadaAsunto ?? '',
  nota: r.nota ?? '',
  empresa: r.empresa ? { id: r.empresa.id, nombre: r.empresa.name ?? 'Partner', correo: r.empresa.correoLicencias ?? '', idioma: r.empresa.idiomaAvisos ?? null } : null,
});

export const licencias3cx = async (empresaId?: string) =>
  (
    await gqlTodos<Raw>('licencias3Cx', 'id name vence edicion perpetua llamadas extensiones tipo estado aviso45 aviso25 avisoInterno cotizada cotizadaAsunto nota empresa{ id name correoLicencias idiomaAvisos }', {
      filtro: empresaId ? { empresaId: { eq: empresaId } } : {},
      orden: [{ vence: 'AscNullsLast' }],
      max: 3000,
    })
  ).map(aLicencia);

export const editarNotaLicencia = (id: string, nota: string) => update('licencias3cx', id, { nota });
// Marcar o desmarcar a mano que ya se envio la cotizacion (cuando no paso por un buzon del CRM).
export const marcarCotizada = (id: string, si: boolean) => update('licencias3cx', id, si ? { cotizada: new Date().toISOString(), cotizadaAsunto: 'Marcada a mano' } : { cotizada: null, cotizadaAsunto: '' });

export type Envio = { empresa: string; correo: string; idioma: 'ES' | 'EN'; umbral: 45 | 25; claves: string[]; enviado: boolean; error?: string };
export type Sincronizacion = { configurada: boolean; licencias: number; nuevas: number; actualizadas: number; renovadas: number; empresasNuevas: number; sinPartner: number; envios: Envio[] };

export const sincronizarLicencias = (simular = false) => request<Sincronizacion>(`/s/3cx/licencias/sincronizar${simular ? '?simular=1' : ''}`, { method: 'POST', body: {} });
export const avisarPartner = (empresaId: string) => request<{ envios: Envio[]; mensaje?: string }>('/s/3cx/licencias/avisar', { method: 'POST', body: { empresaId } });
export const precioRenovacion = (clave: string) =>
  request<{ NetPrice?: number; Price?: number; Currency?: string; Years?: number; Edition?: string; SimultaneousCalls?: number }>('/s/3cx/licencias/precio', { query: { clave } });

// Datos de avisos de licencias del revendedor (ficha de la empresa).
export type DatosLicenciasEmpresa = { partner3cxId: number | null; idioma: 'ES' | 'EN' | null; correo: string; contacto: string };
export async function datosLicenciasEmpresa(empresaId: string): Promise<DatosLicenciasEmpresa> {
  const r = await request<{ data: { company: { partner3cxId?: number | null; idiomaAvisos?: 'ES' | 'EN' | null; correoLicencias?: string | null; contactoLicencias?: string | null } } }>(`/rest/companies/${empresaId}`, { query: { depth: 0 } });
  const c = r.data.company;
  return { partner3cxId: c.partner3cxId ?? null, idioma: c.idiomaAvisos ?? null, correo: c.correoLicencias ?? '', contacto: c.contactoLicencias ?? '' };
}
export const guardarDatosLicenciasEmpresa = (empresaId: string, d: Omit<DatosLicenciasEmpresa, 'partner3cxId'>) =>
  update('companies', empresaId, { idiomaAvisos: d.idioma, correoLicencias: d.correo.trim().toLowerCase(), contactoLicencias: d.contacto.trim() });
